/**
 * Cloud Credit/token API
 */

import Axios from 'axios';

const cloudCreditAPI = Axios.create({
    baseURL: 'https://developer.api.autodesk.com/subscription/v1/thresholds',
    timeout: 2000,
});

// Create CustomThreshold
const createUserCustomThreshold = async ( bearerToken, oxygenId, newThreshold, plan) => {
    cloudCreditAPI.defaults.headers['Authorization'] = `Bearer ${bearerToken}`;
    let threshold_set;
    try {
        threshold_set = await cloudCreditAPI.post('', {
            name: `custom_threshold_${oxygenId}`,
            value: newThreshold,
            is_global: false,
            oxygen_id: oxygenId,
            plan,
        });
    } catch (error) {
        console.error(error);
    }
    return threshold_set.data;
};

// Get Threshold
const getUserThreshold = async (bearerToken, oxygenId ) => {
    cloudCreditAPI.defaults.headers['Authorization'] = `Bearer ${bearerToken}`;
    let threshold = '';
    try {
        threshold = await cloudCreditAPI.get(`/users/${oxygenId}`);
    } catch (error) {
        console.error(error);
    }
    return threshold;
};

// Delete Threshold
const deleteUserThreshold = async (bearerToken, oxygenId) => {
    cloudCreditAPI.defaults.headers['Authorization'] = `Bearer ${bearerToken}`;
    try {
        await cloudCreditAPI.delete(`/custom_threshold_${oxygenId}`);
    } catch (error) {
        console.error(error);
    }
};

// Update Threshold =
const updateUserThreshold = async (bearerToken, oxygenId, newThreshold, plan) => {
    cloudCreditAPI.defaults.headers['Authorization'] = `Bearer ${bearerToken}`;
    let threshold = '';
    try {
        threshold = await cloudCreditAPI.put(`/custom_threshold_${oxygenId}`, {
            name: `custom_threshold_${oxygenId}`,
            value: newThreshold,
            is_global: false,
            oxygen_id: oxygenId,
            plan,
        });
    } catch (error) {
        console.error(error);
    }

    return threshold.data;
};
export {
    createUserCustomThreshold,
    getUserThreshold,
    deleteUserThreshold,
    updateUserThreshold
};